import { httpClient } from "@/shared/services/http";

export class ClientJobsHttpService {
  /**
   * @param {{ clientId: number, locale?: string }} params - the client to list job titles for, and the locale to read them in
   * @returns {Promise<string[]>} the job titles carrying a value in that locale
   */
  static async getClientJobTitles({ clientId, locale }: { clientId: number; locale?: string }): Promise<string[]> {
    const { data } = await httpClient.get<string[]>(`/api/clients/${clientId}/jobs`, {
      params: locale ? { locale } : undefined,
    });
    return data;
  }
}
